module.exports = __webpack_public_path__ + "img/icon-efecty.13bfaa0a.svg";